import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-qa": "store-categories-list"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "gfu-heading__icon gfu-heading__icon--primary gfu-heading__icon--small"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_content_renderer = _resolveComponent("content-renderer")
  const _component_store_product_card_list = _resolveComponent("store-product-card-list")

  return ($options.hasProducts)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.categories, (category) => {
          return (_openBlock(), _createElementBlock("div", {
            key: category.categoryID
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(category.element.component), {
              id: category.element.id,
              ref_for: true,
              ref: category.element.ref,
              class: _normalizeClass(category.element.class),
              "data-qa": category.element.dataQa
            }, {
              default: _withCtx(() => [
                (category.isChildCategory)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createTextVNode(_toDisplayString(category.parentName) + " ", 1 /* TEXT */),
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "_tc--accent _fw-l" }, " » ", -1 /* CACHED */)),
                      _createElementVNode("span", null, _toDisplayString(category.name), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(category.name), 1 /* TEXT */)),
                (category.infoText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_component_tooltip, {
                        text: category.infoText,
                        "icon-name": "circle-info"
                      }, null, 8 /* PROPS */, ["text"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "class", "data-qa"])),
            _createVNode(_component_content_renderer, {
              class: "_mt-2 _mb-1",
              content: category.description
            }, null, 8 /* PROPS */, ["content"]),
            _createVNode(_component_store_product_card_list, {
              products: category.cardModels
            }, null, 8 /* PROPS */, ["products"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}